module.exports = __webpack_public_path__ + "static/media/story.226804e4.png";